module.exports = __webpack_public_path__ + "static/media/wandaLopez.f04e908d.png";